import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/performance_cycles/pages/RootPage'))

const CyclesListPage = React.lazy(() => import('modules/performance_cycles/pages/CyclesListPage'))

export const performanceCyclesRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.performanceCycles.path.replace(`${navigation.performanceProcess.path}/`, ''),
      element: <RootPage />,
      handle: {
        meta: () => {
          return {
            title: i18n.t('performance_cycles.title'),
            illustration: 'schedule',
          }
        },
      },
      children: [
        {
          index: true,
          element: <CyclesListPage />,
        },
      ],
    },
  ]
}
